(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    class ShippingEstimate extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.result = this.querySelector('.shipping-estimate__result');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.estimate();
      });
    }

    // The buy form's variant input follows the picker; products quoted by hand have no form,
    // so fall back to the variant rendered with the block.
    get variantId() {
      const section = this.closest('.shopify-section') || document;
      const input = section.querySelector('product-form-component input[name="id"]');
      return (input && input.value) || this.dataset.variantId;
    }

    get quantity() {
      const section = this.closest('.shopify-section') || document;
      const input = section.querySelector('input[name="quantity"]');
      const value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    async estimate() {
      const country = this.form.country.value;
      const zip = this.form.zip.value.trim();
      if (!country || !zip) {
        this.show('Enter a country and postal code.');
        return;
      }
      const quantity = this.quantity;
      this.show('Getting rates…');
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ variantId: this.variantId, quantity, country, zip }),
        });
        const json = await response.json();
        if (!json.ok) {
          this.show(json.error || 'Could not get rates. Try again.');
          return;
        }
        const options = json.rates.map((rate) => ({ title: rate.title, estimatedCost: { amount: rate.amount, currencyCode: rate.currencyCode } }));
        const countryName = this.form.country.selectedOptions[0].textContent.trim();
        this.render(options, quantity, `${zip}, ${countryName}`);
      } catch (error) {
        console.error('[shipping-estimate]', error);
        this.show('Could not get rates. Try again.');
      }
    }

    render(options, quantity, destination) {
      if (!options.length) {
        this.show(this.dataset.noRates);
        return;
      }
      const rows = options
        .map((option) => {
          const detail = option.description ? `<br><small>${this.escape(option.description)}</small>` : '';
          return `<tr><th>${this.escape(option.title)}${detail}</th><td>${this.money(option.estimatedCost)}</td></tr>`;
        })
        .join('');
      const units = quantity > 1 ? ` · ${quantity} units` : '';
      this.result.innerHTML =
        `<p class="shipping-estimate__caption"><small>Rates to ${this.escape(destination)}${units}</small></p>` +
        `<div class="rte"><table><tbody>${rows}</tbody></table></div>`;
    }

    show(text) {
      this.result.innerHTML = `<p class="shipping-estimate__note">${this.escape(text)}</p>`;
    }

    // Formats with the store's own money format, like the price block; a zero rate is "Free".
    money({ amount, currencyCode }) {
      const value = Number(amount);
      if (value === 0) return 'Free';
      const formatted = this.dataset.moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toLocaleString('en'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        .replace(/<[^>]+>/g, '');
      return this.escape(formatted);
    }

    escape(text) {
      return String(text).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    }
  }

  if (!customElements.get('shipping-estimate')) customElements.define('shipping-estimate', ShippingEstimate);
  } catch(e) { console.error(e); }
})();

})();
